import React, { useEffect } from 'react';

import SimulatorTitle from '../ProductsLanding/08_simulator_title';
import SimulatorFlex from '../ProductsLanding/09_simulator_flex';
import Banners from '../../Molecules/banners';
import bannerImg from '../../Assets/bannersAssets/products_landing.webp';

import '../ProductsLanding/styles/01_banner.css';

export default function Simulator() {
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>    
      <SimulatorTitle />
      <div className="py-2 md:py-0" id="simulators">
        <SimulatorFlex />
      </div>
    </>
  );
}
